import "core-js/modules/es.array.iterator.js";
import { DropPreview } from '@isyc-react/form-file/modules/drop-file/drop-preview';
import { nsnewo } from "../../../i18n/namespaces";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DocumentalValidationStatus } from "../documental-validation-status";
export const DropSingleAcceptedFile = props => {
  const {
    fileValue,
    disabled,
    archiveInputState,
    documentalTypologyResult,
    open,
    remove
  } = props;
  const {
    t
  } = useTranslation(nsnewo.common);
  const [preview, setPreview] = React.useState(false);
  const name = React.useMemo(() => {
    var _fileValue$api;
    return fileValue.file ? fileValue.file.name : (_fileValue$api = fileValue.api) === null || _fileValue$api === void 0 ? void 0 : _fileValue$api.name;
  }, [fileValue]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row text-xl-start align-items-center justify-content-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-9 pb-xl-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row align-items-center pb-4 pb-xl-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-5 pt-2 pt-xl-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "justify-content-center justify-content-xl-start align-items-center pb-2 pb-xl-0"
  }, /*#__PURE__*/React.createElement("u", {
    className: "cursor-pointer",
    onClick: () => {
      setPreview(true);
    }
  }, name))), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center ps-3 justify-content-xl-start align-items-center"
  }, /*#__PURE__*/React.createElement(DocumentalValidationStatus, {
    documentalTypologyResult: documentalTypologyResult,
    archiveInputState: archiveInputState
  }))))), !disabled && /*#__PURE__*/React.createElement("div", {
    className: "col-xl-3 text-center filebox"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-5 pe-4 text-end"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mdi mdi-cloud-upload mdi-48px text-secondary"
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-7 text-start"
  }, /*#__PURE__*/React.createElement("span", null, t('newo.documentalValidation.dropText1'), /*#__PURE__*/React.createElement("br", null), t('newo.documentalValidation.dropText2')))))), /*#__PURE__*/React.createElement(DropPreview, {
    value: fileValue,
    show: preview,
    onChange: setPreview
  }));
};